import {MaybeComputedRef, resolveUnref, UseFetchReturn} from "@vueuse/core";
import {Page} from "../models/common";
import {Comment} from "../models/comment";
import {computed} from "vue";
import {useFetch} from "./fetch";

export function useComments(projectId: MaybeComputedRef<number>, taskId: MaybeComputedRef<number>, page: MaybeComputedRef<number>): UseFetchReturn<Page<Comment>> {
    const url = computed(() =>  {
        const task = resolveUnref(taskId);
        if (task) {
            return`/projects/${resolveUnref(projectId)}/tasks/${resolveUnref(taskId)}/comments?page=${resolveUnref(page)}`
        } else {
            return ``
        }
    })
    return useFetch<Page<Comment>>(url,  {refetch: () => !!url.value})
        .get()
        .json()
}

export function useAddComments(projectId: MaybeComputedRef<number>, taskId: MaybeComputedRef<number>, data: MaybeComputedRef<FormData>): UseFetchReturn<null> {
    const url = computed(() => `/projects/${resolveUnref(projectId)}/tasks/${resolveUnref(taskId)}/comments`)
    return useFetch<null>(url, {immediate: false})
        .post(data)
}


export function useUpdateComments(projectId: MaybeComputedRef<number>, taskId: MaybeComputedRef<number>,  data: MaybeComputedRef<Comment | null>): UseFetchReturn<null> {
    const url = computed(() => `/projects/${resolveUnref(projectId)}/tasks/${resolveUnref(taskId)}/comments/${resolveUnref(data)?.id}`)
    return useFetch<null>(url, {immediate: false})
        .put(data, 'json')
}

export function useDeleteComments(projectId: MaybeComputedRef<number>, taskId: MaybeComputedRef<number>,  data: MaybeComputedRef<Comment | null>): UseFetchReturn<null> {
    const url = computed(() => `/projects/${resolveUnref(projectId)}/tasks/${resolveUnref(taskId)}/comments/${resolveUnref(data)?.id}`)
    return useFetch<null>(url, {immediate: false})
        .delete()
}